var map = {
	"./Aizano.webp": 3107,
	"./Alinda.webp": 7438,
	"./Amalfi.webp": 2905,
	"./Anemon.webp": 2607,
	"./Arena.webp": 4510,
	"./Armilla.webp": 4305,
	"./Artesia.webp": 1329,
	"./Ashen.webp": 9822,
	"./Aspendos.webp": 6220,
	"./Aurica.webp": 8192,
	"./Aurora.webp": 9651,
	"./Avalanche.webp": 4744,
	"./Babilon.webp": 2260,
	"./Belluno SoftTouch.webp": 3625,
	"./Belluno.webp": 4702,
	"./Boletus.webp": 8041,
	"./Cadiz.webp": 5270,
	"./Calacatta Alya.webp": 5466,
	"./Calacatta Garda.webp": 6754,
	"./Calacatta Paletino.webp": 9702,
	"./Calacatta Valencia.webp": 9118,
	"./Calacatta Veneto.webp": 40,
	"./Calacatta Venezia.webp": 8923,
	"./Calacatta Venus.webp": 3442,
	"./Calacatta Verona.webp": 8530,
	"./Calacatta Victory.webp": 8025,
	"./Carola.webp": 3379,
	"./Carrara Luca.webp": 2898,
	"./Chakra Beige.webp": 1445,
	"./Charmy.webp": 7461,
	"./Columbia Gray.webp": 9830,
	"./Daphne Crack.webp": 6043,
	"./Diamond White.webp": 4996,
	"./Elegance.webp": 2573,
	"./Elixir White.webp": 8205,
	"./Everest White.webp": 8080,
	"./Fairy White.webp": 7745,
	"./ForzaFume.webp": 2240,
	"./Gala Black.webp": 6419,
	"./Granada.webp": 7787,
	"./Hypnose.webp": 1011,
	"./Iceberg.webp": 8756,
	"./Juliet White.webp": 17,
	"./Kashmera White.webp": 4562,
	"./Kristella White.webp": 461,
	"./LaLuna.webp": 2066,
	"./Lumiere.webp": 7880,
	"./Marquina Lavagna.webp": 281,
	"./Marquina Tierra.webp": 1800,
	"./Metropol Grey.webp": 9186,
	"./Minta.webp": 3562,
	"./Mocca Mousse.webp": 8332,
	"./Mont Blanc Snow.webp": 1626,
	"./Montana.webp": 8585,
	"./Olympos.webp": 6320,
	"./Pantheon.webp": 6196,
	"./Parma.webp": 7392,
	"./Pergamon.webp": 4976,
	"./Perla White.webp": 2748,
	"./Pixie Wings.webp": 4822,
	"./Polaris.webp": 829,
	"./Premium White.webp": 7925,
	"./Rapture.webp": 6184,
	"./Retro.webp": 4849,
	"./Sahara Beige.webp": 6373,
	"./Spa Black.webp": 2547,
	"./Star dust.webp": 2457,
	"./Statuario Crux.webp": 2083,
	"./Statuario Venetian.webp": 1105,
	"./Statuario Volga.webp": 8974,
	"./Teos.webp": 2958,
	"./Terre Grey.webp": 9286,
	"./Toledo.webp": 4736,
	"./Volcano Black.webp": 2096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2433;